import { render, staticRenderFns } from "./HistoricoProduto.vue?vue&type=template&id=36c37395"
import script from "./HistoricoProduto.vue?vue&type=script&lang=ts"
export * from "./HistoricoProduto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports